import axios from '@/config/api.request'
import qs from 'qs'
// qs.stringfy() 将对象序列化成URL的形式
// https://www.cnblogs.com/edwardwzw/p/11694903.html

export default {
    // 判断用户是否有请求解封权限
    hasRequestUnwrapPermission(nftId) {
        return axios.request({
            url: '/nft/unwrap/permission/request',
            method: 'get',
            params: { nftId: nftId }
        })
    },
    // 判断用户是否有签名解封权限
    hasSignUnwrapPermission(nftId) {
        return axios.request({
            url: '/nft/unwrap/permission/sign',
            method: 'get',
            params: { nftId: nftId }
        })
    },
    // 判断用户是否有确认解封权限
    hasConfirmUnwrapPermission(nftId) {
        return axios.request({
            url: '/nft/unwrap/permission/confirm',
            method: 'get',
            params: { nftId: nftId }
        })
    },
    // 请求解封 NFT
    requestUnwrap(data) {
        return axios.request({
            url: '/nft/unwrap/request',
            method: 'post',
            data: data
        })
    },
    // 签名解封 NFT
    signUnwrap(data) {
        return axios.request({
            url: '/nft/unwrap/sign',
            method: 'post',
            data: data
        })
    },
    // 解封 NFT
    unwrap(data) {
        return axios.request({
            url: '/nft/unwrap/unwrap',
            method: 'post',
            data: data
        })
    },
    // 根据 NFT 主键查询最新一条签名记录
    getUnwrapSignature(nftId) {
        return axios.request({
            url: '/nft/unwrap/signature',
            method: 'get',
            params: { nftId: nftId }
        })
    }
}